<template>
  <div>
    <CommonConfirmationModal
      :dialog="modals.openEleccion"
      @userChoice="(val) => emitChoice('eleccion', val)"
    />

    <CommonInputModal
      :dialog="modals.openRedencionManual"
      @userChoice="(val, folio) => emitChoice('redencionManual', val, folio)"
    />

    <MotivoDialog
      :dialog="modals.openMotivo"
      :rechazo="esRechazo"
      @userChoice="(val, motivo) => emitChoice('motivo', val, motivo)"
    />

    <SolicitudDialog
      v-if="modals.openSolicitud"
      :show="modals.openSolicitud"
      :solicitud="solicitud"
      route="/v1/solicitud/manual"
      categoria="Redención por Excepción"
      @close="emitClose('openSolicitud')"
    />

    <CommonValidationModal
      :dialog="modals.openValidateCode"
      @update:dialog="(val) => (modals.openValidateCode = val)"
      @codigo-validado="emitShowFolio"
    />

    <CommonShowFolio
      :dialog="modals.showFolio"
      :folio="folio"
      @update:dialog="(val) => (modals.showFolio = val)"
    />
  </div>
</template>

<script>
import CommonConfirmationModal from "@/components/commondComponents/CommonConfirmationModal.vue";
import CommonInputModal from "@/components/commondComponents/CommonInputModal.vue";
import MotivoDialog from "@/views/pages/solicitudes/dialogMotivoSolicitud.vue";
import SolicitudDialog from "@/components/solicitudes/solicitudDialogForm.vue";
import CommonValidationModal from "@/components/commondComponents/CommonValidationModal.vue";
import CommonShowFolio from "@/components/commondComponents/CommonShowFolio.vue";

export default {
  name: "SolicitudActions",
  components: {
    CommonConfirmationModal,
    CommonInputModal,
    MotivoDialog,
    SolicitudDialog,
    CommonValidationModal,
    CommonShowFolio,
  },
  props: {
    modals: {
      type: Object,
      required: true,
    },
    solicitud: {
      type: Object,
      required: true,
    },
    folio: {
      type: String,
      default: "",
    },
    esRechazo: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["choice", "close", "showFolio"],
  methods: {
    emitChoice(type, ...args) {
      this.$emit("choice", { type, args });
    },
    emitClose(type) {
      this.$emit("close", type);
    },
    emitShowFolio(folio) {
      this.$emit("showFolio", folio);
    },
  },
};
</script>
